import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[nullValue]'
})
export class NullValueDirective {

  constructor(private control: NgControl) { }

  @HostListener('input', [ '$event.target' ])
  onEvent(target: HTMLInputElement) {
    this.control.control.patchValue((target.value === '') ? null : target.value);
  }

}
